export { KokorokoLogo } from "./KokorokoLogo";
